import { Box, Button, Modal, Typography } from '@mui/material'
import { colors } from '~constants/colorsPallete'

const style = {
  position: 'absolute' as const,
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '40%',
  maxWidth: 800,
  bgcolor: 'background.paper',
  borderRadius: 4,
  boxShadow: 24,
  p: 4,
}

export default function ModalRefusalReason({
  open,
  handleClose,
  reason,
}: {
  open: boolean
  handleClose: VoidFunction
  reason?: string | null
}) {
  return (
    <Modal open={open} onClose={handleClose} aria-labelledby="refusal-reason-title">
      <Box sx={style}>
        <Typography id="refusal-reason-title" variant="h6" component="h2" fontWeight={800} mb={1}>
          Motivo do erro
        </Typography>
        <Typography variant="body1" sx={{ whiteSpace: 'pre-wrap' }}>
          {reason || '--'}
        </Typography>
        <Box mt={3} display="flex" justifyContent="flex-end">
          <Button
            onClick={handleClose}
            variant="outlined"
            sx={{ borderColor: colors['gray.600'], color: colors['gray.600'], px: 4 }}
          >
            Fechar
          </Button>
        </Box>
      </Box>
    </Modal>
  )
}
